var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-item",on:{"click":_vm.productClicked}},[_c('div',{staticClass:"product-inner buider-mode"},[_c('div',{staticClass:"product-image",style:(_vm.backgroundImage)}),_vm._v(" "),_c('div',{staticClass:"product-name text-truncate"},[_vm._v("\n      "+_vm._s(_vm.wardrobeProduct.product.brand_name)+"\n    ")])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209b1dcf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/capsuleBuilder/modals/addProductModal/Product.vue
// module id = csyb
// module chunks = 0